import { MultiCodeBlock, VideoFrame } from '@imgly-labs/gatsby-theme-imgly-docs';
import * as React from 'react';
export default {
  MultiCodeBlock,
  VideoFrame,
  React
};